<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="section-heading">ONE.</p>
<p class="section-heading1">Someone’s Angel</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?386b97a6